const state = {
    inventarioList: [],
    fromInventario: false,
    prv_id: null
}

const actions = {
    _setPrvID(store, prv_id) {
        store.commit("setPrvID", prv_id)
    },
    _removePrvID(store) {
        store.commit("setPrvID", null)
    }
}

const mutations = {
    addList(state, lista) {
        state.fromInventario = true
        state.inventarioList = []
        for (let item of lista) {
            state.inventarioList.push(item)
        }
    },
    cancelInventario(state) {
        state.fromInventario = false
    },
    setPrvID(state, prv_id) {
        state.prv_id = prv_id
    }
}

const getters = {
    lista: state => state.inventarioList,
    fromInv: state => state.fromInventario,
    _prv_id: state => state.prv_id
}

export const product = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
